import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import BrandsPage from 'src/dispensary/brands';

BrandsPage.layout = MainDispensaryLayout;
export default BrandsPage;
